const getActionSchema = async ({ rootGetters, dispatch }, { actionType }) => {
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/workflows/action-config/${actionType}?customer_id=${data.customer_id}`, data);
        if (response && response.data.success) {
            return response.data.schema;
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    }
};

export default getActionSchema;